module.exports = __webpack_public_path__ + "img/logo-vivalis.6cdd2ec3.png";